module.exports = __webpack_public_path__ + "img/bg_sidenav.a09c2e7e.png";